/* Aurelle — all custom JavaScript (vanilla, no dependencies). */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var fmt = (window.IL && window.IL.moneyFormat) || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      switch (name) {
        case 'amount': return withDelimiters(cents, 2);
        case 'amount_no_decimals': return withDelimiters(cents, 0);
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return withDelimiters(cents, 0, ' ', '.');
        default: return withDelimiters(cents, 2);
      }
    });
  }

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var els = $$('.il-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('il-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('il-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- announcement bar ---------- */
  function initAnnounce() {
    $$('[data-il-announce]').forEach(function (bar) {
      var items = $$('.il-announce__item', bar);
      if (items.length < 2) return;
      var i = 0;
      var every = parseInt(bar.getAttribute('data-interval'), 10) || 4000;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, every);
    });
  }

  /* ---------- mobile menu ---------- */
  function initMenu() {
    var btn = $('[data-il-menu-toggle]');
    var menu = $('#IlMobileMenu');
    if (!btn || !menu) return;
    btn.addEventListener('click', function () {
      var open = menu.hasAttribute('hidden');
      if (open) { menu.removeAttribute('hidden'); } else { menu.setAttribute('hidden', ''); }
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- cart drawer ---------- */
  var drawerEl = null;
  function getDrawer() { return drawerEl || (drawerEl = $('[data-il-drawer]')); }

  function openDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function refreshDrawer() {
    var root = (window.IL && window.IL.root) || '/';
    return fetch(root + '?sections=il-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['il-cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var newPanel = $('.il-drawer__panel', tmp);
        var oldPanel = $('.il-drawer__panel', getDrawer());
        if (newPanel && oldPanel) {
          oldPanel.innerHTML = newPanel.innerHTML;
          var count = parseInt(newPanel.getAttribute('data-count'), 10) || 0;
          $$('[data-il-cart-count]').forEach(function (b) {
            b.textContent = count;
            b.setAttribute('data-count', count);
          });
        }
      });
  }

  function changeLine(line, qty) {
    return fetch((window.IL && window.IL.cartChangeUrl) || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(refreshDrawer);
  }

  function initDrawer() {
    var d = getDrawer();
    if (!d) return;

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-il-cart-open]');
      if (opener) {
        e.preventDefault();
        refreshDrawer().then(openDrawer);
        return;
      }
      if (e.target.closest('[data-il-drawer-close]')) {
        closeDrawer();
        return;
      }
      var lineBtn = e.target.closest('[data-il-line]');
      if (lineBtn && d.contains(lineBtn)) {
        changeLine(parseInt(lineBtn.getAttribute('data-il-line'), 10), Math.max(0, parseInt(lineBtn.getAttribute('data-il-qty'), 10)));
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); closeModals(); }
    });
  }

  /* ---------- modals ---------- */
  function closeModals() {
    $$('[data-il-modal].is-open').forEach(function (m) { m.classList.remove('is-open'); });
  }
  function initModals() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-il-modal-open]');
      if (opener) {
        var m = document.getElementById(opener.getAttribute('data-il-modal-open'));
        if (m) m.classList.add('is-open');
        return;
      }
      if (e.target.closest('[data-il-modal-close]') || (e.target.matches && e.target.matches('[data-il-modal]'))) {
        closeModals();
      }
    });
  }


  /* ---------- size guide finder ---------- */
  function initSizeGuide() {
    $$('[data-il-sizeguide]').forEach(function (box) {
      var under = $('[data-sg-under]', box), bust = $('[data-sg-bust]', box), out = $('[data-sg-result]', box);
      if (!under || !bust || !out) return;
      function range(txt) {
        var m = String(txt).replace(',', '.').match(/(\d+(?:\.\d+)?)\s*[-\u2013]\s*(\d+(?:\.\d+)?)/);
        return m ? [parseFloat(m[1]), parseFloat(m[2])] : null;
      }
      function dist(v, r) { return v < r[0] ? r[0] - v : (v > r[1] ? v - r[1] : 0); }
      function nearest(v, items) {
        var best = null;
        items.forEach(function (it) {
          if (!it.r) return;
          var d = dist(v, it.r), mid = Math.abs(v - (it.r[0] + it.r[1]) / 2);
          if (!best || d < best.d || (d === best.d && mid < best.mid)) best = { it: it, d: d, mid: mid };
        });
        return best;
      }
      var bands = [], cups = [], rows = [];
      $$('[data-sg-band] tr', box).slice(1).forEach(function (tr) {
        var c = $$('td,th', tr).map(function (x) { return x.textContent.trim(); });
        bands.push({ label: c[0], r: range(c[c.length - 1]) });
      });
      var cupTable = $('[data-sg-cup]', box);
      if (cupTable) {
        var trs = $$('tr', cupTable);
        cups = $$('th', trs[0]).slice(1).map(function (x) { return x.textContent.trim(); });
        trs.slice(1).forEach(function (tr) {
          var c = $$('th,td', tr).map(function (x) { return x.textContent.trim(); });
          var m = c[0].match(/=\s*(\d+)/);
          rows.push({ label: m ? m[1] : c[0], cells: c.slice(1) });
        });
      }
      function fill(tpl, map) { return tpl.replace(/\{(\w+)\}/g, function (_, k) { return map[k] || ''; }); }
      function calc() {
        var u = parseFloat(under.value), b = parseFloat(bust.value);
        if (!u || !b) { out.textContent = ''; out.classList.remove('is-on', 'is-warn'); return; }
        var band = nearest(u, bands);
        var row = band && rows.filter(function (r) { return r.label === band.it.label; })[0];
        if (!band || band.d > 2.5 || !row) { return show(box.getAttribute('data-out-text'), true); }
        var cell = nearest(b, row.cells.map(function (c) { return { r: range(c) }; }));
        if (!cell || cell.d > 3) { return show(box.getAttribute('data-out-text'), true); }
        var cupIdx = 0;
        row.cells.forEach(function (c, i) { if (range(c) && range(c)[0] === cell.it.r[0] && range(c)[1] === cell.it.r[1]) cupIdx = i; });
        var cup = (cups[cupIdx] || '').split(/\s+/)[0];
        var chartSize = band.it.label + cup;
        var up = box.getAttribute('data-sizeup') === 'true';
        var bi = bands.indexOf(band.it);
        var next = bands[Math.min(bi + 1, bands.length - 1)].label + cup;
        var tpl = up ? box.getAttribute('data-sizeup-text') : box.getAttribute('data-sizeup-none');
        var map = { chart: chartSize, size: up ? next : chartSize };
        show(fill(tpl, map), false);
      }
      function show(msg, warn) {
        out.textContent = msg; out.classList.add('is-on'); out.classList.toggle('is-warn', !!warn);
      }
      under.addEventListener('input', calc);
      bust.addEventListener('input', calc);
    });
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    var variantsEl = $('[data-il-variants]', root);
    var form = $('[data-il-form]', root);
    if (!variantsEl || !form) return;

    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch (err) { return; }

    var idInput = $('[data-il-variant-id]', form);
    var qtyInput = $('[data-il-quantity]', form);
    var atc = $('[data-il-atc]', form);
    var atcLabel = $('[data-il-atc-label]', form);
    var priceEl = $('[data-il-price]', root);
    var stickyPrice = $('[data-il-sticky-price]', root);
    var stickyBtn = $('[data-il-sticky-btn]', root);
    var bundleRadios = $$('input[name="il-bundle"]', root);
    var addLabel = atcLabel ? atcLabel.textContent : 'Add to bag';
    var currentVariant = null;

    /* gallery */
    var slides = $('[data-il-slides]', root);
    var thumbs = $$('[data-il-thumb]', root);
    function showImage(id, smooth) {
      if (!slides) return;
      var target = $('[data-il-slide="' + id + '"]', slides);
      if (!target) return;
      slides.scrollTo({ left: target.offsetLeft - slides.offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-il-thumb') === String(id)); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showImage(t.getAttribute('data-il-thumb'), true); });
    });
    if (slides && 'IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6) {
            var id = en.target.getAttribute('data-il-slide');
            thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-il-thumb') === id); });
          }
        });
      }, { root: slides, threshold: [0.6] });
      $$('[data-il-slide]', slides).forEach(function (s) { sio.observe(s); });
    }

    /* variants */
    function selectedOptions() {
      return $$('[data-il-option]', form).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }
    function findVariant() {
      var opts = selectedOptions();
      if (!opts.length) return variants[0];
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return v['option' + (i + 1)] === o; });
      })[0] || null;
    }
    function bundleInfo() {
      var checked = bundleRadios.filter(function (r) { return r.checked; })[0];
      if (!checked) return { qty: 1, discount: 0 };
      return { qty: parseInt(checked.getAttribute('data-qty'), 10) || 1, discount: parseFloat(checked.getAttribute('data-discount')) || 0 };
    }
    function priceHtml(v) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        return '<span class="il-price__now il-price__now--sale">' + formatMoney(v.price) + '</span><s class="il-price__was">' + formatMoney(v.compare_at_price) + '</s>';
      }
      return '<span class="il-price__now">' + formatMoney(v.price) + '</span>';
    }
    function render() {
      var v = findVariant();
      currentVariant = v;
      var b = bundleInfo();

      $$('[data-il-option]', form).forEach(function (fs) {
        var checked = $('input:checked', fs);
        var label = $('[data-il-option-label]', fs);
        if (checked && label) label.textContent = checked.value;
      });

      /* mark sold-out values for the first option axis combos */
      $$('[data-il-option]', form).forEach(function (fs, idx) {
        var opts = selectedOptions();
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var match = variants.filter(function (vv) {
            return test.every(function (o, i) { return vv['option' + (i + 1)] === o; });
          })[0];
          var lbl = inp.nextElementSibling;
          if (lbl) lbl.classList.toggle('is-soldout', !!match && !match.available);
        });
      });

      var available = !!(v && v.available);
      if (v) {
        idInput.value = v.id;
        if (priceEl) priceEl.innerHTML = priceHtml(v);
        if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
        if (v.featured_image && v.featured_image.id) showImage(v.featured_image.id, true);
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* ignore */ }

        /* bundle prices */
        bundleRadios.forEach(function (r) {
          var q = parseInt(r.getAttribute('data-qty'), 10) || 1;
          var d = parseFloat(r.getAttribute('data-discount')) || 0;
          var wrap = r.closest('[data-il-bundle-option]');
          var full = v.price * q;
          var total = Math.round(full * (100 - d) / 100);
          var totalEl = $('[data-il-bundle-total]', wrap);
          var wasEl = $('[data-il-bundle-was]', wrap);
          if (totalEl) totalEl.textContent = formatMoney(total);
          if (wasEl) wasEl.textContent = formatMoney(full);
        });
      }

      qtyInput.value = b.qty;
      $$('[data-il-bundle-option]', root).forEach(function (el) {
        var r = $('input', el);
        el.classList.toggle('is-selected', r && r.checked);
      });

      atc.disabled = !available;
      if (stickyBtn) stickyBtn.disabled = !available;
      if (atcLabel) {
        if (!v) { atcLabel.textContent = 'Unavailable'; atc.disabled = true; }
        else if (!available) { atcLabel.textContent = 'Sold out'; }
        else {
          var total = Math.round(v.price * b.qty * (100 - b.discount) / 100);
          atcLabel.textContent = addLabel + ' • ' + formatMoney(total);
        }
      }
    }

    form.addEventListener('change', render);

    /* preselect bundle from ?bundle= */
    try {
      var wanted = new URL(window.location.href).searchParams.get('bundle');
      if (wanted) {
        var match = bundleRadios.filter(function (r) { return r.getAttribute('data-qty') === wanted; })[0];
        if (match) {
          match.checked = true;
          var bsec = $('[data-il-bundles]', root);
          if (bsec && window.location.hash !== '') bsec.scrollIntoView({ block: 'center' });
        }
      }
    } catch (e) { /* ignore */ }

    render();

    /* add to bag (AJAX, then open drawer) */
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !currentVariant || !currentVariant.available) { return; }
      e.preventDefault();
      var original = atcLabel ? atcLabel.textContent : '';
      atc.disabled = true;
      if (atcLabel) atcLabel.textContent = 'Adding...';
      fetch((window.IL && window.IL.cartAddUrl ? window.IL.cartAddUrl : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: currentVariant.id, quantity: parseInt(qtyInput.value, 10) || 1 }] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to bag'); });
          return r.json();
        })
        .then(function () { return refreshDrawer(); })
        .then(function () { openDrawer(); render(); })
        .catch(function (err) {
          if (atcLabel) atcLabel.textContent = err.message;
          setTimeout(render, 2500);
        });
    });

    /* sticky mobile bar */
    var sticky = $('[data-il-sticky]', root);
    if (sticky && 'IntersectionObserver' in window) {
      var sio2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var below = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', below);
          sticky.setAttribute('aria-hidden', below ? 'false' : 'true');
        });
      }, { threshold: 0 });
      sio2.observe(atc);
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) { form.requestSubmit(atc); } else { atc.click(); }
      });
    }
  }

  function init() {
    initReveal();
    initAnnounce();
    initMenu();
    initDrawer();
    initModals(); initSizeGuide();
    $$('[data-il-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init inside the theme editor when sections reload */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target;
    $$('[data-il-product]', root).forEach(initProduct);
    $$('.il-reveal', root).forEach(function (el) { el.classList.add('il-visible'); });
  });
})();
